'use client';

export interface AccordionLink {
  type: 'file' | 'external';
  url?: string;
  label?: string;
  metadata?: { filename?: string };
}

export const tryAlternativeDownload = async (link: AccordionLink, originalUrl: string): Promise<boolean> => {
  try {
    const variants = [
      originalUrl.replace('https://cdn.sanity.io/files/', 'https://cdn.sanity.io/files/'),
      originalUrl.replace('.com/files/', '.io/files/'),
      originalUrl.replace('.io/files/', '.com/files/'),
    ];

    for (const altUrl of variants) {
      if (altUrl === originalUrl) continue;
      try {
        const resp = await fetch(altUrl, { method: 'HEAD' });
        if (resp.ok) {
          const ct = resp.headers.get('content-type');
          if (ct && !ct.includes('text/html')) {
            const a = document.createElement('a');
            a.href = altUrl;
            a.download = link.metadata?.filename || link.label || 'download';
            a.target = '_blank';
            a.rel = 'noopener noreferrer';
            document.body.appendChild(a);
            a.click();
            a.remove();
            return true;
          }
        }
      } catch {}
    }
    return false;
  } catch {
    return false;
  }
};

export const handleLinkClick = async (link: AccordionLink, event: React.MouseEvent): Promise<void> => {
  event.preventDefault();

  if (link.type === 'file') {
    if (!link.url || link.url === '#') {
      alert('Unable to download file: Invalid file URL');
      return;
    }
    try {
      try {
        const a = document.createElement('a');
        a.href = link.url;
        a.download = link.metadata?.filename || link.label || 'download';
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        document.body.appendChild(a);
        a.click();
        a.remove();
      } catch {
        window.open(link.url, '_blank', 'noopener,noreferrer');
      }
    } catch {
      const ok = await tryAlternativeDownload(link, link.url!);
      if (!ok) {
        if (link.url && link.url !== '#') {
          window.open(link.url, '_blank', 'noopener,noreferrer');
        } else {
          alert('Unable to download file. Please try again later.');
        }
      }
    }
  } else {
    if (link.url && link.url !== '#') {
      window.open(link.url, '_blank', 'noopener,noreferrer');
    }
  }
};
